import { h, Component } from "preact";

import TicketDisplay from "./TicketDisplay";
import TicketGroup from "./TicketGroup";

class TicketOrder extends Component {
  render({
    tickets,
    ticketGroups,
    addTicketQuantity,
    ticketSelection,
    updateDonationAmount,
    ticketsRemainingDisplay,
    showCustomDonationField,
    addTicketPrice
  }) {
    // find tickets which are not in the groups
    const ticketIdsInGroups = ticketGroups.reduce((ticketIds, group) => {
      return ticketIds.concat(group.tickets);
    }, []);
    const ticketsNotInGroups = ticketSelection.tickets.reduce(
      (tickets, ticket) => {
        if (ticketIdsInGroups.indexOf(ticket._id) == -1) {
          tickets.push(ticket);
        }
        return tickets;
      },
      []
    );
    const donationOtherOption = ticketSelection.donationOtherOption
      ? ticketSelection.donationOtherOption
      : false;
    return (
      <div>
        {ticketsNotInGroups.map(ticket => {
          if (ticket.ticketGroup) {
            return (
              <TicketGroup
                group={ticket}
                tickets={tickets}
                updateDonationAmount={updateDonationAmount}
                addQuantity={addTicketQuantity}
                addPrice={addTicketPrice}
                ticketsRemainingDisplay={ticketsRemainingDisplay}
                showCustomDonationField={showCustomDonationField}
                donationOtherOption={donationOtherOption}
              />
            );
          }
          return (
            <TicketDisplay
              tickets={tickets}
              ticket={ticket}
              updateDonationAmount={updateDonationAmount}
              addQuantity={addTicketQuantity}
              addPrice={addTicketPrice}
              ticketsRemainingDisplay={ticketsRemainingDisplay}
              showCustomDonationField={showCustomDonationField}
              donationOtherOption={donationOtherOption}
            />
          );
        })}
      </div>
    );
  }
}

export default TicketOrder;



// WEBPACK FOOTER //
// ./routes/tickets/components/TicketOrder.js